module.exports = __webpack_public_path__ + "img/3.c12da52b.png";